import { BatteryFull, Locate, Nut, Timer, Watch } from "lucide-react";
import React, { useEffect, useState } from "react";


const EVENTS = [
  {
    id: 1,
    title: "Data Science with Python",
    description:
      "Understand core data science concepts, EDA and model basics using Python.",
    dateTime: "2025-02-25T17:00:00", // 25 Feb 2025, 5:00 PM
    location: "Online • Live",
    image: "https://picsum.photos/400/550?random=501"
  },
  {
    id: 2,
    title: "Mobile App Development Bootcamp",
    description:
      "Learn to build modern mobile apps with React Native and best practices.",
    dateTime: "2026-02-28T15:00:00", // 28 Feb 2025, 3:00 PM
    location: "Online • Live",
    image: "https://picsum.photos/400/550?random=502"
  },
  {
    id: 3,
    title: "Mobile App Development Bootcamp",
    description:
      "Learn to build modern mobile apps with React Native and best practices.",
    dateTime: "2026-02-28T15:00:00", // 28 Feb 2025, 3:00 PM
    location: "Online • Live",
    image: "https://picsum.photos/400/550?random=502"
  }
];

function getTimeLeft(targetISO) {
  const total = Date.parse(targetISO) - Date.now();
  if (total <= 0) {
    return { d: 0, h: 0, m: 0, s: 0, expired: true };
  }

  const d = Math.floor(total / (1000 * 60 * 60 * 24));
  const h = Math.floor((total / (1000 * 60 * 60)) % 24);
  const m = Math.floor((total / (1000 * 60)) % 60);
  const s = Math.floor((total / 1000) % 60);

  return { d, h, m, s, expired: false };
}


const EventCard2 = () => {
  const [timers, setTimers] = useState(
    EVENTS.map((ev) => getTimeLeft(ev.dateTime))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimers(EVENTS.map((ev) => getTimeLeft(ev.dateTime)));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (<>
    <section className="evc-2-up-events">
      <div className="evc-2-header">
        <h2>UPCOMING EVENTS</h2>
        <p>
          Level up your preparation with our live strategy workshops and get
          closer to your dream exam.
        </p>
      </div>

      <div className="evc-2-events-row">
        {EVENTS.map((event, idx) => {
          const t = timers[idx] || { d: 0, h: 0, m: 0, expired: true };

          return (
            <article key={event.id} className="evc-2-event-card">
              <div className="evc-2-avatar-wrap">
                <img src={event.image} alt={event.title} />
              </div>

              <div className="evc-2-event-content">
                <h3>{event.title}</h3>
                <p className="evc-2-event-desc">{event.description}</p>

                <div className="evc-2-meta-row">
                  <span><Nut size={15} color={`rgba(144, 202, 249,1)`}/> {new Date(event.dateTime).toLocaleDateString()}</span>
                  <span>
                    <Watch size={18} color={`rgba(144, 202, 249,1)`}/>{" "}
                    {new Date(event.dateTime).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit"
                    })}
                  </span>
                </div>

                <div className="evc-2-meta-row">
                  <span><Locate size={18} color={`rgba(144, 202, 249,1)`}/> {event.location}</span>
                </div>

                <div className="evc-2-countdown">
                  {t.expired ? (
                    <span className="expired-evc-2"><BatteryFull size={18} color={`rgba(144, 202, 249,1)`}/> Event started / finished</span>
                  ) : (
                    <span>
                      <Timer size={18} color={`rgba(144, 202, 249,1)`}/> Starts in: <strong>{t.d}d</strong> {t.h}h {t.m}m {t.s}s
                    </span>
                  )}
                </div>

                <button className="evc-2-enroll-btn">Enroll Now</button>
              </div>
            </article>
          );
        })}
      </div>

      <div className="evc-2-view-all-wrap">
        <button className="evc-2-view-all-btn">View All Events</button>
      </div>
    </section>
    <style>{`.evc-2-up-events {
  padding: 60px 8%;
  background: #ffffff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.evc-2-header {
  text-align: center;
  margin-bottom: 40px;
}

.evc-2-header h2 {
  font-size: 30px;
  letter-spacing: 1px;
  font-weight: 800;
  margin-bottom: 10px;
}

.evc-2-header p {
  max-width: 620px;
  margin: 0 auto;
  color: #666;
  font-size: 14px;
}

/* Events row */
.evc-2-events-row {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.evc-2-event-card {
  display: flex;
  align-items: center;
  gap: 20px;
  max-width: 480px;
  padding: 20px 10px;
}

/* Circular image */
.evc-2-avatar-wrap {
  flex-shrink: 0;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.evc-2-avatar-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Content */
.evc-2-event-content h3 {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 6px;
  text-transform: uppercase;
}

.evc-2-event-desc {
  font-size: 13px;
  color: #555;
  margin: 0 0 10px;
}

.evc-2-meta-row {
  font-size: 13px;
  color: #555;
  display: flex;
  gap: 20px;
  margin-bottom: 4px;
}

.evc-2-countdown {
  margin: 10px 0 14px;
  font-size: 13px;

  color: rgba(144, 202, 249,1);
  padding: 6px 10px;
  border-radius: 6px;
  display: inline-block;
}

.evc-2-countdown .expired-evc-2 {
  display:flex;justify-content:left;gap:10px;
  color: rgba(144, 202, 249,1)
}

.evc-2-enroll-btn {
  border: none;
  background: rgba(144, 202, 249,1);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.25s;
}

.evc-2-enroll-btn:hover {
  background: rgba(144, 202, 249,1);
}

/* View all button */
.evc-2-view-all-wrap {
  text-align: center;
  margin-top: 30px;
}

.evc-2-view-all-btn {
  border: none;
  background: rgba(144, 202, 249,1);
  color: #fff;
  padding: 10px 26px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.25s;
}

.evc-2-view-all-btn:hover {
  background: rgba(144, 202, 249,1);
}

/* Responsive */
@media (max-width: 900px) {
  .evc-2-event-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .evc-2-meta-row {
    justify-content: center;
  }
}
`}</style>
  </>);
};

export default EventCard2;
